import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito saber cocinar?',
    answer: 'No. Cada receta incluye instrucciones simples paso a paso. Si puedes hervir agua, puedes prepararlas.'
  }, {
    question: '¿Cómo recibo el pack de recetas?',
    answer: 'De forma 100% digital e inmediata. Apenas completes tu compra recibes acceso a todo el contenido en tu correo.'
  }, {
    question: '¿Sirve para perros y gatos?',
    answer: 'Sí. Incluye recetas y guías nutricionales específicas tanto para perros como para gatos en todas las etapas.'
  }, {
    question: '¿Y si no me gusta?',
    answer: 'Tienes 7 días de garantía. Si no cumple tus expectativas, te devolvemos tu dinero sin preguntas.'
  }, {
    question: '¿Los ingredientes son fáciles de conseguir?',
    answer: 'Sí. Todas las recetas están diseñadas con ingredientes accesibles que encuentras en cualquier supermercado o verdulería.'
  }, {
    question: '¿Funciona para cachorros y mascotas mayores?',
    answer: 'Sí. El pack incluye recetas y planes nutricionales adaptados para cada etapa: cachorros, adultos y mascotas mayores.'
  }, {
    question: '¿Las recetas reemplazan al veterinario?',
    answer: 'No. Las recetas complementan el cuidado integral de tu mascota. Siempre recomendamos consultar a tu veterinario ante cualquier condición médica.'
  }, {
    question: '¿Puedo verlo desde el celular?',
    answer: 'Sí. Todo el contenido es compatible con celular, tablet y computadora. Lo descargas una vez y queda para siempre.'
  }, {
    question: '¿Las actualizaciones tienen costo extra?',
    answer: 'No. Todas las actualizaciones futuras están incluidas sin costo adicional. Pagas una sola vez y recibes mejoras de por vida.'
  }, {
    question: '¿Cómo es el proceso de pago?',
    answer: 'El pago es 100% seguro y protegido. Puedes pagar con tarjeta de crédito, débito o medios electrónicos disponibles en el checkout.'
  }];
  return <section className="bg-gray-50 py-10 md:py-14" data-id="element-35">
      <div className="max-w-3xl mx-auto px-5" data-id="element-36">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-ink text-center mb-6" data-id="element-37">
          Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-38">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-39">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors text-left" data-id="element-40">
                <span className="font-semibold text-gray-800 pr-4" data-id="element-41">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-42" />
              </button>
              {openIndex === index && <div className="px-6 py-4 border-t border-gray-200" data-id="element-43">
                  <p className="text-gray-600" data-id="element-44">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}